import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getFaqs } from './module';

const initialState = {
    pages_data: null,
    status: "idle",
    ActionStatus: "",
    errorMessage: ""
};

export const PagesAsync = createAsyncThunk(
    'Faqs/getFaqs',
    async (index, ThunkAPI) => {
        const response = await getFaqs();
        // const resultPromise = Promise.resolve(response);
        // resultPromise.then(() => {
        //     ThunkAPI.dispatch(clearAction());
        // })
        return response;
    }
);

export const FaqsSlice = createSlice({
    name: 'Faqs',
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(PagesAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(PagesAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(PagesAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            state.pages_data = action.payload;
            state.pages_data = state.pages_data ? state.pages_data.FAQs : '';

            if(action.payload && action.payload.Status !== 'OK'){
                alert(action.payload.ErrorMessage)
            }
        });
    }
});

export const pagesData = (state) => state.faqs.pages_data;
export const pagesState = (state) => state.faqs;

export default FaqsSlice.reducer;
